import React, { useEffect, useRef, useState } from 'react';
import config from "../../../config.json";

const BASE_URL = config.SERVER_URL;
const HeatMapComponent = () => {
    const mapRef = useRef(null);
    const heatmapRef = useRef(null);
    const [latLongData, setLatLongData] = useState([]);

    const GOOGLE_MAP_API_KEY = 'AIzaSyAuRDL2eK79L6Pu6kv940Ngej_TeRy61SI';

    // Load Google Maps Script
    const loadGoogleMapsScript = (callback) => {
        const existingScript = document.getElementById('googleMapsScript');

        if (!existingScript) {
            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_API_KEY}&libraries=visualization`;
            script.id = 'googleMapsScript';
            script.async = true;
            script.defer = true;
            script.onload = callback;
            document.body.appendChild(script);
        } else {
            callback();
        }
    };

    // Fetch API data
    const fetchData = async () => {
        try {
            const response = await fetch(BASE_URL + '/dashboard/getLatLong'); // Replace with actual API
            const data = await response.json();
            setLatLongData(data);
        } catch (error) {
            console.error('Failed to fetch lat/long data:', error);
        }
    };

    // Initialize Map and Heatmap
    const initializeMap = () => {
        if (!window.google || !latLongData.length) return;

        const map = new window.google.maps.Map(mapRef.current, {
            center: { lat: 25.2657473, lng: 90.7313245 }, // Center of India
            zoom: 7,
        });

        const heatmapData = latLongData.map(
            (item) =>
                new window.google.maps.LatLng(
                    parseFloat(item.latitude),
                    parseFloat(item.longitude)
                )
        );

        const heatmap = new window.google.maps.visualization.HeatmapLayer({
            data: heatmapData,
            radius: 40,
            opacity: 1,
        });

        heatmap.setMap(map);
        heatmapRef.current = heatmap;
    };

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if (latLongData.length > 0) {
            loadGoogleMapsScript(() => {
                initializeMap();
            });
        }
    }, [latLongData]);

    return (
        <div>
            <h3 style={{ textAlign: 'center' }}>Google Heatmap</h3>
            <div
                ref={mapRef}
                style={{ width: '100%', height: '800px', border: '1px solid #ccc' }}
            />
        </div>
    );
};

export default HeatMapComponent;
